module.exports = __webpack_public_path__ + "img/let-that-shit-go_B09NRD74D1.64ab9179.jpg";